import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ConfigApiServiceProvider } from '../../providers/config-api-service/config-api-service';
import { ConfigureServiceProvider } from '../../providers/configure-service/configure-service';
import { AlertController, Events, LoadingController, NavParams, ToastController, ViewController } from 'ionic-angular';
import { DriveServiceProvider } from '../../providers/drive-service/drive-service';
import { DomSanitizer } from '@angular/platform-browser';
import { EncrDecrServiceProvider } from '../../providers/encr-decr-service/encr-decr-service';
import { EventServiceProvider } from '../../providers/event-service/event-service';
import { LoginService } from '../../providers/login-service/login-service';
import { CommunicationServiceProvider } from '../../providers/communication-service/communication-service';
import * as XLSX from 'xlsx'
@Component({
  selector: 'createapp-modal',
  templateUrl: 'createapp-modal.html',
})
export class CreateAppModal implements OnInit {
  createAppForm: FormGroup = new FormGroup({});
  postData: any;
  appDetail: any;

  app_icon: any;
  appScreenStatus: any;
  popupLabel: any;
  uploadFile: any;
  tmAppUrl: string;
  urlSafe: any;
  importFolder: boolean = false;
  app_code: any;
  loader: any;
  APP_CODE = [];
  AppcreationAppCode: any;
  showDeleteBtn: boolean = false;
  broadcastSubs: any;
  filejson = [];
  appSpace: any = {};
  disableField: boolean = false;
  appSettingsMenu: boolean = false;
  storageSpace: any;
  storageSpaceLabel: any;
  storageLabel: any;
  importFile: any;
  myImgUrl: string = 'assets/imgs/epc_logo1.png';
  constructor(
    private formBuilder: FormBuilder,
    private configureServiceProvider: ConfigureServiceProvider,
    private configApiService: ConfigApiServiceProvider,
    public toastController: ToastController,
    private viewCtrl: ViewController,
    private driveService: DriveServiceProvider,
    public navParams: NavParams,
    public events: Events,
    public sanitizer: DomSanitizer,
    private EncrDecrService: EncrDecrServiceProvider,
    private loadingController: LoadingController,
    private alertCtrl: AlertController,
    private eventObj: EventServiceProvider,
    private loginServ: LoginService,
    public communicationServ: CommunicationServiceProvider
  ) {
    this.formGroupInitialize();
    this.broadcastSubs = this.communicationServ.getInstance()
      .subscribe((data: any) => {
        if (data.src === "iframeData") {
          if (data.event === 'folderTemplateCreateAuto') {
            let status = data['status'];
            if (status == true) {
              let toast = this.toastController.create({
                message: data['importFolderData'],
                duration: this.configApiService.toastDuration,
                position: 'top'
              });
              toast.present();
              this.viewCtrl.dismiss({})
              this.loader.dismiss()
            }
          }
        }
      })
  }


  formGroupInitialize() {
    this.createAppForm = this.formBuilder.group({
      "appName": new FormControl('', [Validators.required]),
      "appDescription": new FormControl(''),
      "appIcon": new FormControl(''),
    })
  }

  get f() {
    return this.createAppForm.controls;
  }

  ngOnInit(): void {
    this.appDetail = this.navParams.get('appDetail') || '';
    this.appScreenStatus = this.navParams.get('status');
    this.popupLabel = this.appScreenStatus == "Edit" ? "App Management" : "Create App";
    if (this.appScreenStatus == "Edit") {
      if (Object.keys(this.driveService.appSpace).length != 0) {
        this.appSpace = this.driveService.appSpace;
        this.roundOfSpace();
      } else {
        this.fetchAppMemory();
      }
    }
    if (this.appDetail != '') {
      this.uploadFile = this.appDetail.app_icon
      this.createAppForm.setValue({
        appName: this.appDetail.app_name,
        appDescription: this.appDetail.app_description,
        appIcon: this.appDetail.app_icon,
      });
    }
    if (this.uploadFile == null) {
      this.uploadFile = this.myImgUrl;

    }
    console.log(this.createAppForm.value)
  }


  fetchAppMemory() {
    let pullParams = {
      userid: this.configureServiceProvider.getLoginUserID(),
      StudioApp_Code: this.configureServiceProvider.getStudio(),
      App_Code: this.configApiService.currentDriveApp['app_code']
    }
    let objData = Object.assign({}, this.configApiService.driveApi.fetchAppMemory, pullParams)
    this.configApiService.pushRequest(objData, this.fetchMemory)
  }

  fetchMemory = (respData) => {
    console.log('rep', respData);
    this.appSpace = respData;
    this.roundOfSpace();
    this.driveService.appSpace = respData;
  }

  roundOfSpace() {
    var add_val = this.appSpace.DataSpace_MB + this.appSpace.IndexSpace_MB
    var div_val = add_val / this.appSpace.ReservedSpace_MB
    this.storageSpace = Math.round(div_val * 100);
    this.storageSpaceLabel = 'Storage (' + this.storageSpace + '% full)';
    this.storageLabel = Math.round(add_val) + ' ' + 'MB of' + ' ' + Math.round(this.appSpace.ReservedSpace_MB) + " " + 'MB used'
  }

  onSubmit() {
    if (this.createAppForm['value']['appName'] != "") {
      if (this.appScreenStatus == "Edit") {
        this.updateAppProperties();
      } else {
        this.createApp();
      }
    } else {
      this.createAppForm.markAllAsTouched();
    }
  }


  createApp() {
    this.postData = {
      "app_name": this.createAppForm['value']['appName'],
      "app_description": this.createAppForm['value']['appDescription'],
      "app_icon": this.uploadFile,
      "host": this.configureServiceProvider.getHost(),
      "email_id": this.configureServiceProvider.getLoginData()["user"],
      "password": this.configureServiceProvider.getLoginData()["pass"],
    }
    let objCreateAppdata = Object.assign({}, this.configApiService.driveApi.createApp.params, this.postData);
    var duplicateAppNameIndex = this.driveService.driveApps.findIndex(obj => obj.app_name == this.createAppForm['value']['appName'])
    if (duplicateAppNameIndex == -1) {
      this.configApiService.customRequest(this.configApiService.createAppApi, objCreateAppdata, (resp) => {

        if (JSON.parse(resp._POST_EPC_SETUP_APPResult)[0] == "SUCCESS") {
          if (this.APP_CODE.length == 0) {
            let toast = this.toastController.create({
              message: 'App has been created successfully',
              duration: this.configApiService.toastDuration,
              position: 'top'
            });
            toast.present()
            this.viewCtrl.dismiss({})
          } else {
            this.AppcreationAppCode = JSON.parse(resp._POST_EPC_SETUP_APPResult)[1]
            let toast = this.toastController.create({
              message: 'App has been created successfully',
              duration: this.configApiService.toastDuration,
              position: 'top'
            });
            toast.present()
            this.configApiService.getFolderTemplate(this.APP_CODE[0], this.cbck)
          }

          this.configApiService.getApplist((appList) => {
            this.driveService.driveApps = appList;
            this.AppcreationAppCode = JSON.parse(resp._POST_EPC_SETUP_APPResult)[1]
            this.driveService.driveApps.forEach(element => {
              if (element.app_code == this.AppcreationAppCode) {
                this.configApiService.currentDriveApp = element;
                this.driveService.broadcastInfo({ src: 'createApp', event: 'newApp', data:element });
              }
            });
            console.log(this.driveService.driveApps)

          })

        } else {
          let toast = this.toastController.create({
            message: 'App has not been created! Please try again..',
            duration: this.configApiService.toastDuration,
            position: 'top'
          });
          toast.present();
        }
      });
    } else {
      let toast = this.toastController.create({
        message: 'App Name Already Exits! Please try again..',
        duration: this.configApiService.toastDuration,
        position: 'top'
      });
      toast.present();
    }

  }

  updateAppProperties() {
    this.postData = {
      "app_name": this.createAppForm['value']['appName'],
      "app_description": this.createAppForm['value']['appDescription'],
      "app_icon": this.uploadFile,
      "host": this.configureServiceProvider.getHost(),
      "app_code": this.appDetail.app_code,
      "email_id": this.configureServiceProvider.getLoginData()["user"],
      "password": this.configureServiceProvider.getLoginData()["pass"],
    }
    let objUpdateAppdata = Object.assign({}, this.configApiService.driveApi.updateApp.params, this.postData);
    this.configApiService.customRequest(this.configApiService.createAppApi, objUpdateAppdata, (resp) => {
      this.viewCtrl.dismiss({});
      if (JSON.parse(resp._POST_EPC_SETUP_APPResult)[0] == "SUCCESS") {
        let toast = this.toastController.create({
          message: 'App has been Updated successfully',
          duration: this.configApiService.toastDuration,
          position: 'top'
        });
        toast.present();
        this.configApiService.getApplist((appList) => {
          this.driveService.driveApps = appList;
          this.driveService.driveApps.forEach(element => {
            if (element.app_code == this.appDetail.app_code) {
              this.configApiService.currentDriveApp = element;
            }
          });
        })
      } else {
        let toast = this.toastController.create({
          message: 'App has not been created! Please try again..',
          duration: this.configApiService.toastDuration,
          position: 'top'
        });
        toast.present();
      }
    });
  }

  imageUpload(event) {
    var formData = new FormData();
    this.uploadFile = event.name;
    formData.append("file", event)
    this.configApiService.uploadFile(formData, this.submitSucess)

  }
  submitSucess = (respData) => {
    this.uploadFile = respData;
  }

  exportFolder() {
    this.createAppForm.reset()
    this.uploadFile = ''
    this.appDetail = '';
    this.appScreenStatus = 'AutomaticProgress'
  }

  driveAutomaticProcess() {
    // this.configApiService.templateMangerUrl = 'http://localhost:8101/?server=local&host=https://prodcast.cloud:3780'
    let urlParams = '&appCode=' + this.AppcreationAppCode + '&studio=' + this.configureServiceProvider.getStudio() + '&userid=' + this.configureServiceProvider.getLoginUserID() + '&importFolder=' + JSON.stringify(this.configApiService.exportFolderJSON) + '&importTemplate=' + JSON.stringify(this.configApiService.exportTempalateJSON);
    let encUrlParams = this.EncrDecrService.encrypt('DRIVESYNC123##', urlParams);
    this.tmAppUrl = this.configApiService.templateMangerUrl + '&templateParams=' + encUrlParams;
    if (this.urlSafe == undefined) {
      this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.tmAppUrl);
    }
    this.importFolder = true;
    this.presentLoading()
  }

  presentLoading() {
    this.loader = this.loadingController.create({
      spinner: 'ios',
      content: 'template Importing Please wait...'
    });
    this.loader.present();
  }


  ExportApp() {
    //this.configApiService.templateMangerUrl = 'http://localhost:8101/?server=local&host=https://prodcast.cloud:3780'
    let urlParams = '&appCode=' + this.configApiService.currentDriveApp['app_code'] + '&studio=' + this.configureServiceProvider.getStudio() + '&userid=' + this.configureServiceProvider.getLoginUserID() + '&exportFolder=';
    let encUrlParams = this.EncrDecrService.encrypt('DRIVESYNC123##', urlParams);
    this.tmAppUrl = this.configApiService.templateMangerUrl + '&templateParams=' + encUrlParams;
    if (this.urlSafe == undefined) {
      this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.tmAppUrl);
    }
    this.importFolder = true;
    this.presentLoading()
  }

  DeleteApp() {
    let alert = this.alertCtrl.create({
      title: 'Delete APP',
      message: 'Are you sure, Do you want to Delete this app?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel'
        },
        {
          text: 'Ok',
          handler: data => {
            let deleteData = {
              "targetepc": this.configApiService.currentDriveApp['app_code'],
            }
            let objDeleteAppdata = Object.assign({}, this.configApiService.driveApi.deleteApp.params, deleteData);
            this.configApiService.customRequest(this.configApiService.deleteAppApi, objDeleteAppdata, (resp) => {
              if (resp['_POST_EPC_DELETE_EPCResult'] == "SUCCESS") {
                this.viewCtrl.dismiss();
                this.driveService.callComponentMethod("")
              }
            });
          }
        }
      ]
    });
    alert.present();
  }

  importApp(evt: any) {
    /* wire up file reader */
    if (evt.target.files.length != 0) {
      this.APP_CODE = []
      var excelFile = evt.target.files[0]
      var exelFiles = excelFile.name.split('.')
      if (exelFiles[1] == "json") {
        const target: DataTransfer = <DataTransfer>evt.target;
        const reader: FileReader = new FileReader();
        reader.onload = (e: any) => {
          /* read workbook */
          const bstr: string = e.target.result;
          const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

          /* grab first sheet */
          const wsname: string = wb.SheetNames[0];
          const ws: XLSX.WorkSheet = wb.Sheets[wsname];

          /* save data */
          this.filejson = XLSX.utils.sheet_to_json(ws, { header: 1 });
          this.APP_CODE.push({ "AppCode": this.filejson[0][0] })
          console.log(this.filejson[0])
          let toast = this.toastController.create({
            message: this.filejson[0][0] + "" + "appcode selected",
            duration: this.configApiService.toastDuration,
            position: 'bottom'
          });
          toast.present();
        };
        reader.readAsBinaryString(target.files[0]);
      } else {
        let toast = this.toastController.create({
          message: 'Invaild Format',
          duration: this.configApiService.toastDuration,
          position: 'bottom'
        });
        toast.present();
      }
    } else {
      let toast = this.toastController.create({
        message: 'Please select the file',
        duration: this.configApiService.toastDuration,
        position: 'top'
      });
      toast.present();
    }
  }
  cbck = (resp) => {
    this.configApiService.exportFolderJSON = JSON.parse(resp).folderPath;
    this.configApiService.exportTempalateJSON = JSON.parse(resp).templatePath;
    this.driveAutomaticProcess()
  }

  showMenu() {
    this.appSettingsMenu = true;
  }

  onFileSelected(event) {
    if (event.target.files.length > 0) {
      console.log(event.target.files[0].name);
      var re = /(?:\.([^.]+))?$/;
      var ext = re.exec(event.target.files[0].name)[1];
      if (ext == 'png' || ext == 'jpg' || ext == "pdf" || ext == "docx" || ext == 'doc' || ext == "txt" || ext == "xls" || ext == "xlsx" || ext == "json") {
        let ImportFile = event.target.files[0].name;
        this.importFile = ImportFile;
        this.imageUpload(event.target.files[0])

      } else {
        alert('Not a valid image!');
      }
    }
  }

  ngOnDestroy() {
  }
}



// WEBPACK FOOTER //
// ./src/pages/createapp-modal-popup/createapp-modal.ts